import { useQuery } from '@tanstack/react-query';
import { teamsService } from '../services/teams.service';
import type { GetAllTeamsApiRequest } from '@momentum/types';

// Query keys for teams
export const teamKeys = {
  all: ['teams'] as const,
  lists: () => [...teamKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) =>
    [...teamKeys.lists(), { filters }] as const,
  onboarding: (filters: Record<string, unknown>) =>
    [...teamKeys.lists(), 'onboarding', { filters }] as const,
};

// Get all teams
export const useTeams = (
  params?: GetAllTeamsApiRequest,
  enabled = true,
  isOnboarding = false
) => {
  return useQuery({
    queryKey: isOnboarding
      ? teamKeys.onboarding(params || {})
      : teamKeys.list(params || {}),
    queryFn: () =>
      isOnboarding
        ? teamsService.getAllTeamsForOnboarding(params)
        : teamsService.getAllTeams(params),
    enabled: enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};
